var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.38623C7.35954 1.38809 5.78681 2.04058 4.62683 3.20056C3.46685 4.36054 2.81436 5.93328 2.8125 7.57373C2.8125 12.8683 8.4375 16.8669 8.67727 17.0343C8.77184 17.1005 8.88452 17.1361 9 17.1361C9.11548 17.1361 9.22816 17.1005 9.32273 17.0343C9.5625 16.8669 15.1875 12.8683 15.1875 7.57373C15.1856 5.93328 14.5331 4.36054 13.3732 3.20056C12.2132 2.04058 10.6405 1.38809 9 1.38623ZM9 5.32373C9.44501 5.32373 9.88002 5.45569 10.25 5.70292C10.62 5.95016 10.9084 6.30156 11.0787 6.71269C11.249 7.12383 11.2936 7.57623 11.2068 8.01268C11.12 8.44914 10.9057 8.85005 10.591 9.16472C10.2763 9.47939 9.87541 9.69368 9.43895 9.7805C9.0025 9.86732 8.5501 9.82276 8.13896 9.65246C7.72783 9.48216 7.37643 9.19377 7.12919 8.82376C6.88196 8.45375 6.75 8.01874 6.75 7.57373C6.75 6.97699 6.98705 6.4047 7.40901 5.98274C7.83097 5.56078 8.40326 5.32373 9 5.32373Z",
    fill: "#F27C06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.38d49c8362d7058c41016f0f9ff92e90.svg";
export { ForwardRef as ReactComponent };